import { IItem } from "./items";

/**
 * 1つのフォーマットにつき1つのItemSetが存在
 * フォーマット内のオブジェクトすべてがItemSetに格納される
 * オブジェクトを識別するためのキーはprivateIdとして表現している
 */
export class ItemSet {
  constructor(public formatId: number, items: IItem[]) {
    this.items = [];
    for (const item of items) {
      if (item) {
        this.items[item.privateId] = item;
      }
    }
  }

  // id―itemの辞書はただの配列にする.(データ構造が実装の都合に振り回されるのは避けたいが...)
  // ・TypeScriptのインデックスシグネチャ({ [key: number]: IItem; })はfor(in)等のループがまともに動作しないのでやめる.
  //   ->デバッガで見るとただの配列にも見える？
  // ・ES2015のMapは、Vueのリアクティブシステムが機能しない.(対応してない？)
  // ・idは飛ぶことはありえるが全体の比率としては少ない事が予想されるため.
  // ・単純に速い？(計測は必要だが...おそらく空きによるロスを上回ると想像できる.)
  public items: IItem[];  // インデックスシグネイチャでなくただの配列にする.(keyがnumberだとループが処理できない等問題が多いため.)

  clone(): ItemSet {
    return new ItemSet(this.formatId, this.items.concat());
  }

  freezeItems(): void {
    for (const item of this.items) {
      if (!item) { continue; }
      Object.freeze(item);
    }
  }
}
